/*
 * profile-dropdown
 */
import { useNavigate } from "@tanstack/react-router"
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@psychology/react-ui"
import type { AuthUser } from "@psychology/types"
import { LogOut, User, UserPen } from "lucide-react"

type ProfileDropdownProps = {
	user?: AuthUser
	registerUrl: string
	loginUrl: string
	logoutUrl: string
	accountUrl: string
}

export function ProfileDropdown({
	user,
	registerUrl,
	loginUrl,
	logoutUrl,
	accountUrl,
}: ProfileDropdownProps) {
	const navigate = useNavigate()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button className={"cursor-pointer rounded-full p-1 hover:bg-white/10"}>
					<User className={"size-5"} />
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align={"end"}>
				{user ? (
					<>
						<DropdownMenuItem onClick={() => navigate({ to: accountUrl })}>
							<User className={"mr-2 size-4"} />
							{"Account"}
						</DropdownMenuItem>
						<DropdownMenuSeparator />
						<DropdownMenuItem onClick={() => navigate({ to: logoutUrl })}>
							<LogOut className={"mr-2 size-4"} />
							{"Logout"}
						</DropdownMenuItem>
					</>
				) : (
					<>
						<DropdownMenuItem onClick={() => navigate({ to: loginUrl })}>
							<User className={"mr-2 size-4"} />
							{"Login"}
						</DropdownMenuItem>
						<DropdownMenuItem onClick={() => navigate({ to: registerUrl })}>
							<UserPen className={"mr-2 size-4"} />
							{"Register"}
						</DropdownMenuItem>
					</>
				)}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
